import avatarModule from '../avatarModule';

function emotesItemCard(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.emotesItemCard
  };
}

avatarModule.directive('emotesItemCard', emotesItemCard);

export default emotesItemCard;
